module.exports = __webpack_public_path__ + "media/assets/images/icons/resource-generic/file-tiny-847aa0abbbc1448f18a18f5a9a51eedb.png";